import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'

/**
 * 配置涉及的接口
 */
export default class widgetConfigApi {
  /**
   *  根据id 、name 查询当前应用下 字典类型 -- 分页  list
   * @param id 、name
   */
  static getDicTypeList(id, name, page, limit) {
    if (formUtils.isNull(id)) {
      alertUtils.alertWarning('查询字典类型列表ID不能为空', true)
      return
    }
    if (formUtils.isNull(name)) {
      name = ''
    }
    if (page === null || page === 0) {
      page = 1
    }
    if (limit === null || limit === 0) {
      limit = 30
    }
    return request({
      url:
        config.baseAPI +
        '/v1/dictionary/getAllDictTypeByFormId?id=' +
        id +
        '&name=' +
        name +
        '&page=' +
        page +
        '&limit=' +
        limit,
      method: 'get',
    })
  }
}
